import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { SettingsService } from '../../../core/settings/settings.service';
import { MsisdnInputDirective } from '@app/shared/directives/msisdn-input.directive';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { AppFocusableDirective } from '@app/shared/directives/focusable.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { MsisdnInputIdService } from '@app/shared/services/msisdn-input-id.service';

@Component({
  selector: 'app-msisdn-input',
  templateUrl: './msisdn-input.component.html',
  styleUrl: './msisdn-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MsisdnInputDirective,
    ReactiveFormsModule,
    InputErrorsComponent,
    AppFocusableDirective,
    TranslatePipe,
    AsyncPipe,
  ],
  host: {
    '[id]': `wrapperId()`,
  },
})
export class MsisdnInputComponent {
  @ViewChild('input') public input: ElementRef;
  @Input() public passedFormControl: UntypedFormControl;
  @Input() public showLabel = true;
  @Input() public showErrors = false;
  @Input() public readonly = false;
  @Input() public required = true;
  @Input() public formErrors: any = null;
  @Input() public icon = true;
  @Input() public controlName: string;
  @Input() public autoPrependWithPlus = false;
  @Output() public editClicked = new EventEmitter<boolean>();

  private readonly settingsService = inject(SettingsService);
  private readonly msisdnInputIdService = inject(MsisdnInputIdService);

  protected readonly settings$ = this.settingsService.getSettingsOnce();

  public readonly wrapperId = signal<string | null>(null);

  protected id: string;
  protected controlUID: number;

  constructor() {
    const { inputId, wrapperId, controlUIDCounter } = this.msisdnInputIdService.getMsisdnInputIds();
    this.id = inputId;
    this.wrapperId.set(wrapperId);
    this.controlUID = controlUIDCounter;
  }
}
